export default "__VITE_PUBLIC_ASSET__f9041881__"